import { CssBaseline, ThemeProvider, useMediaQuery } from "@mui/material";
import { RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { makeRouter } from "./app/routes";
import { consoleDarkTheme, consoleLightTheme } from "./ui/theme/consoleTheme";
import "@fontsource/hanken-grotesk/400.css";
import "@fontsource/hanken-grotesk/500.css";
import "@fontsource/hanken-grotesk/600.css";
import "@fontsource/hanken-grotesk/700.css";
import "@fontsource/jetbrains-mono/400.css";
import "@fontsource/jetbrains-mono/500.css";

// The flowsjs design system, so the console reads as part of the product, light or dark as the
// system asks. Fonts are bundled rather than fetched from a CDN: the console is an administration
// surface and should not make third-party requests.

// One router for the life of the page: recreating it would discard history and remount every
// route on each render.
const router = makeRouter();

function Themed(): React.JSX.Element {
  const dark = useMediaQuery("(prefers-color-scheme: dark)");
  return (
    <ThemeProvider theme={dark ? consoleDarkTheme : consoleLightTheme}>
      <CssBaseline />
      <RouterProvider router={router} />
    </ThemeProvider>
  );
}

const root = document.getElementById("root");
if (root === null) throw new Error("Missing #root");
createRoot(root).render(
  <StrictMode>
    <Themed />
  </StrictMode>,
);
